<template>
  <ec-flex full vertical>
    <ec-flex full alignItems="center" style="margin-bottom: 8px">
      <div class="panel-title">{{ title }}</div>
      <slot name="action"></slot>
    </ec-flex>

    <ec-flex full vertical>
      <slot></slot>
    </ec-flex>
  </ec-flex>
</template>
<script lang="ts" setup>
import { computed } from "vue"

const props = withDefaults(
  defineProps<{
    title?: string
  }>(),
  {
    title: "",
  }
)
</script>
<style scoped>
.panel-title {
  color: #333;
  font-size: 16px;
  font-weight: 500;
  flex-shrink: 0;
  margin-right: 16px;
}
</style>
